import React, { useState } from "react";
import { Plus, Check } from "lucide-react";
import { motion } from "framer-motion";

const COLORS = ["#25D366", "#3B82F6", "#8B5CF6", "#06B6D4", "#EC4899", "#F97316", "#64748B", "#EF4444"];

export default function NewColumnButton({ onCreate }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [color, setColor] = useState(COLORS[0]);

  const submit = () => {
    if (!name.trim()) return;
    onCreate?.({ name: name.trim(), color });
    setName("");
    setColor(COLORS[0]);
    setOpen(false);
  };

  if (!open) {
    return (
      <button
        data-testid="new-column-btn"
        onClick={() => setOpen(true)}
        className="w-80 min-w-[20rem] h-14 rounded-xl border-2 border-dashed border-slate-700 hover:border-[#25D366]/60 hover:bg-[#25D366]/5 text-slate-500 hover:text-[#25D366] flex items-center justify-center gap-2 text-sm font-semibold transition shrink-0"
      >
        <Plus className="w-4 h-4" /> Nova Etapa
      </button>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      className="w-80 min-w-[20rem] shrink-0 bg-slate-800/60 border border-slate-700 rounded-xl p-3 space-y-3"
      data-testid="new-column-form"
    >
      <input
        autoFocus
        data-testid="new-column-name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && submit()}
        placeholder="Nome da etapa"
        className="w-full bg-slate-900 border border-slate-700 rounded-md px-3 py-2 text-sm text-slate-100 placeholder-slate-500 focus:outline-none focus:border-[#25D366]/60"
      />
      <div className="flex items-center gap-1.5 flex-wrap">
        {COLORS.map((c) => (
          <button
            key={c}
            data-testid={`new-column-color-${c}`}
            onClick={() => setColor(c)}
            className="w-6 h-6 rounded-full ring-offset-2 ring-offset-slate-800 flex items-center justify-center transition"
            style={{
              backgroundColor: c,
              boxShadow: color === c ? `0 0 0 2px ${c}` : "none",
            }}
          >
            {color === c && <Check className="w-3 h-3 text-white" strokeWidth={3} />}
          </button>
        ))}
      </div>
      <div className="flex gap-2">
        <button
          onClick={() => setOpen(false)}
          className="flex-1 px-3 py-1.5 rounded-md text-xs font-semibold text-slate-400 hover:bg-slate-700/50 transition"
        >
          Cancelar
        </button>
        <button
          data-testid="new-column-submit"
          onClick={submit}
          disabled={!name.trim()}
          className="flex-1 px-3 py-1.5 rounded-md text-xs font-semibold bg-[#25D366] hover:bg-[#1EAC52] disabled:bg-slate-700 disabled:text-slate-500 text-slate-950 transition"
        >
          Criar
        </button>
      </div>
    </motion.div>
  );
}
